// this is only for mobile
import { FETCH_FILTERED_DATA } from './actionTypes'

export default () => ({
  type: FETCH_FILTERED_DATA,
  payload: {}
})